import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const NextArrow = props => {
  const { onClick } = props;
  return (
    <Box
      pos="absolute"
      textAlign={'center'}
      top={{ base: '20%', md: '25%', lg: '45%' }}
      zIndex="10"
      cursor="pointer"
      right={{ base: '10px', lg: '-19px' }}
      bgSize="13px"
      onClick={onClick}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="20"
          cy="20"
          r="20"
          transform="matrix(-1 0 0 1 40 0)"
          fill="white"
        />
        <path d="M17 12L25 20L17 28" stroke="black" strokeWidth="2.5" />
      </svg>
    </Box>
  );
};

const PrevArrow = props => {
  const { onClick } = props;
  return (
    <Box
      pos="absolute"
      borderRadius="100%"
      top={{ base: '20%', md: '25%', lg: '45%' }}
      zIndex="10"
      cursor="pointer"
      bgSize="13px"
      bgColor="#fff"
      left={{ base: '10px', lg: '-19px' }}
      onClick={onClick}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="20" fill="white" />
        <path d="M23 12L15 20L23 28" stroke="black" strokeWidth="2.5" />
      </svg>
    </Box>
  );
};

export default function GenTopCarouselSection({ sectionContent }) {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    centerPadding: 0,
    appendDots: dots => (
      <Flex
        bottom="30px"
        display={{ base: 'none', md: 'block' }}
        className="custom dots for slider"
      >
        <Flex
          margin="auto"
          height="7px"
          zIndex={5}
          borderRadius="9px"
          justifyContent="space-around"
        >
          <ul style={{ margin: '0px' }} className="slideDots">
            {dots}
          </ul>
        </Flex>
      </Flex>
    ),
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <Box
      maxW={{
        base: '100%',
        sm: '540px',
        md: '720px',
        lg: '960px',
        xl: '1170px',
        '2xl': '1330px',
      }}
      pb={{ base: '30x', md: '40px', xl: '60px' }}
      mx="auto"
      m="0 auto"
    >
      <Box w="full" height="full" position="relative" minH="560px">
        {sectionContent[0]?.slides.length > 1 ? (
          <Slider {...settings}>
            {sectionContent[0].slides.map(item => (
              <SlideContent key={nanoid()} item={item} />
            ))}
          </Slider>
        ) : (
          <SlideContent item={sectionContent[0].slides[0]} />
        )}
      </Box>
      <style jsx global>{`
        .slideDots li {
          width: 5px;
        }
        .st-text p {
          margin-bottom: 5px !important;
        }
        .slideDots li button:before {
          color: #ffffff;
          width: 9px;
          height: 9px;
          font-size: 9px;
          opacity: 1;
        }
        .slideDots li.slick-active button:before {
          color: #f27123;
          width: 13px;
          height: 13px;
          font-size: 13px;
          opacity: 1;
        }
      `}</style>
    </Box>
  );
}

const SlideContent = ({ item }) => (
  <Box
    width="full"
    h={{ md:'870px',  sm: '740px', lg: '440px', xl: '560px' }}
    minH={{  md: '800px', sm:'740px', lg: '440px', xl: '560px' }}
    bgSize="cover"
    display="flex"
    bgImage={{ base: 'none', lg: item?.desktopImage?.url }}
    bgPos="right top"
    bgRepeat="no-repeat"
  >
    <Box
      width="full"
      minW="320px"
      bgColor={{ base: '#00002D', lg: 'transparent' }}
    >
      <Box display={{ lg: 'none' }}>
        <Image
          width="100%"
          src={item?.mobileImage?.url}
          alt={item?.mobileImage?.alt || ''}
          objectFit="cover"
          objectPosition="top"
          height={{ base: '320px', md: '560px' }}
        />
      </Box>

      <Box
        height={{ base: 'auto', md: '360px', lg: '100%' }}
        w={{ base: '100%', md: '100%', lg: '40%', xl: '42%' }}
        p={{ base: '6px', md: '4%', lg: '2%', xl: '4%' }}
        pt={{base: '2.5rem'}}
        display="flex"
        flexDir="column"
        bgColor={{ base: '#00002D', lg: '#020100' }}
        justifyContent="space-between"
      >
        <Box>
          <Box px="10px">
            <Text
              fontFamily="var(--FedraSansStd-medium), sans-serif"
              fontWeight={500}
              fontSize={{ base: '30px', lg: '30px' }}
              lineHeight="120%"
              color="#FFF"
              as="h1"
              textTransform="uppercase"
            >
              {item.title}
            </Text>
          </Box>

          <Box margin={{ base:'15px 15px 0px 10px', sm:'15px 15px 0px 10px', lg:'15px 30px 0px 10px'}}>
          <Text className="noP">
            <StructuredTextParser
              str={render(item.titleSubtext)}
              color="#F27123"
              fontSize="20px"
              lineHeight="136%"
            />
          </Text>
            <Text fontSize="16px" lineHeight="24px" fontWeight={400}>
              <StructuredTextParser
                str={render(item.description)}
                fontSize="16px"
                lineHeight="160%"
                color="#FDE7C3"
              />
            </Text>
          </Box>
        </Box>

        <Box px="10px" mb="0">
          <Text
            fontWeight={600}
            fontSize="24px"
            lineHeight="33px"
            color="#FFFFFF"
          >
            <StructuredTextParser
              str={render(item.date)}
              fontSize="24px"
              color="#FFFFFF"
              textTransform={'uppercase'}
              lineHeight="136%"
              mb="5px"
            />
          </Text>
          <Text
            fontSize={{ base: '18px', lg: '18px' }}
            lineHeight="136%"
            color="#F58220"
            fontWeight={400}
          >
            <StructuredTextParser
              str={render(item.bottomText)}
              fontSize={{ base: '18px', lg: '18px' }}
              color="#F58220"
              fontWeight="400"
              // fontFamily="var(--FedraSansStd-medium), sans-serif"
            />
          </Text>
        </Box>
      </Box>
    </Box>
  </Box>
);
